import { render, staticRenderFns } from "./EncoderSystem.vue?vue&type=template&id=671e5c90"
import script from "./EncoderSystem.vue?vue&type=script&lang=js"
export * from "./EncoderSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports